import { OrderStatusEnum } from 'src/app/enum/order-status/order-status.enum';
import { VerticalType } from 'src/app/enum/vertical-type/verticalType.enum';

export interface ServiceDate {
  completeDate: string;
  date: string;
  offset: string;
  time: string;
  timeZone: string;
  _completeDate: string;
  _date: string;
  _offset: string;
  _time: string;
  _timeZone: string;
}

export interface ZonedDate {
  completeDate?: string | null;
  date?: string | null;
  time?: string | null;
  offset?: string | null;
  timeZone?: string | null;
}

export interface HistoricDriverEvent {
  date?: ZonedDate | null;
  reason?: string | null;
}

export interface HistoricService {
  serviceGuid: string;
  licensePlate: string;
  orderHash: string;
  orderStatus: OrderStatusEnum;
  serviceDate: ZonedDate;
  zoneGuid: string;
  zoneName: string;
  verticalType: number;
  productName: string;
  clientName: string;
  originAddress: string;
  destinationAddress: string;
  driversName?: string[];
  additionalInformation: string;
  totalPrice: number;
  totalPriceWithoutTax: number;
  approvedExpensesAmount?: number;
  phoneNumber: string;
  clientGuid: string;
  productGuid: string;
  currencySymbol: string;
  urgencyFee: number;
  category?: string;
  serviceType: number;
  driverName: string;
  productPrice: number;
  mobilityPrice: number;
  delayDescription?: string;
  cancellationDescription?: string;
  failureDescription?: string;
  isAvailableForFreelancePool?: boolean;
  /**
   * Importe que cobra el driver freelance. El back lo devuelve a 0 para los
   * servicios que nunca fueron al pool, asi que hay que leerlo junto a
   * isAvailableForFreelancePool para distinguir un pool a 0 de un no-pool.
   */
  freelanceCustomPrice?: number;
  /**
   * Direccion del proveedor que atiende el servicio, sacada de los nodos de ruta.
   * Viene vacia en los servicios que no pasan por un proveedor, como los transfer,
   * y lleva varias separadas por comas cuando el servicio pasa por mas de uno.
   */
  providerAddress?: string;
  /**
   * Eventos de tarea del conductor (inicio, fin o fallo) en orden cronologico. El
   * texto del evento ya lleva el nombre del conductor. Solo lo rellena el listado
   * completo que usa el export, el paginado no lo trae.
   */
  driverEvents?: HistoricDriverEvent[];
}

export interface RawHistoricService {
  serviceGuid: string;
  licensePlate: string;
  orderHash: string;
  orderStatus: OrderStatusEnum;
  serviceDate: RawServiceDate;
  zoneGuid: string;
  zoneName: string;
  verticalType: number;
  productName: string;
  productGuid: string;
  clientName: string;
  originAddress: string;
  destinationAddress: string;
  additionalInformation: string;
  phoneNumber: string;
  clientGuid?: string;
  displayDate?: string;
  displayTime?: string;
  totalPrice: number;
  totalPriceWithoutTax: number;
  approvedExpensesAmount?: number;
  currencySymbol: string;
}

export interface RawServiceDate {
  completeDate: string;
  date: string;
  time: string;
  offset: string;
  timeZone: string;
}

export interface GetAllServicesResponse {
  services: HistoricService[];
}

export interface GetPaginatedServicesRequest {
  fromDate: string;
  toDate: string;
  zoneGuids?: string[];
  productsName?: string[];
  clientsGuid?: string[];
  serviceStatus?: number[];
  verticalTypes?: number[];
  pageSize: number;
  pageNumber: number;
  serviceFilter?: string;
}

export interface GetPaginatedServicesResponse {
  services: HistoricService[];
  totalItems: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}
